import React, { useEffect, useState } from "react";
import useHttp from '../../../../hook/use-http';
import { Chart } from 'react-google-charts';
import NoData from '../../../../componets/Dashboard/Driveanalysis/NoData';
import ChartLoader from '../../../../componets/Dashboard/Driveanalysis/ChartLoader';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import WaterMark from "../../../../componets/Dashboard/DashboardMain/WaterMark";

function RealWorldBar({ apiend, gloablfilter }) {
  const [chartdata, setChartData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const appyData = (data) => {
    const res_result = data;
    let responce =
    {
      "<160": { per: 0, count: 0 },
      "180": { per: 0, count: 0 },
      "200": { per: 0, count: 0 },
      "220": { per: 0, count: 0 },
      "240": { per: 0, count: 0 },
      ">240": { per: 0, count: 0 },
    };

    if (res_result.length != 0) {
      let t_val = res_result[0];
      if (t_val.doc_count != 0) {
        if (t_val.less_160.value > 0) {
          responce["<160"] = { per: parseInt((t_val.less_160.value / t_val.doc_count) * 100), count: parseInt(t_val.less_160.value) };
        }
        if (t_val.B160_180.value > 0) {
          responce["180"] = { per: parseInt((t_val.B160_180.value / t_val.doc_count) * 100), count: parseInt(t_val.B160_180.value) };
        }
        if (t_val.B180_200.value > 0) {
          responce["200"] = { per: parseInt((t_val.B180_200.value / t_val.doc_count) * 100), count: parseInt(t_val.B180_200.value) };
        }
        if (t_val.B200_220.value > 0) {
          responce["220"] = { per: parseInt((t_val.B200_220.value / t_val.doc_count) * 100), count: parseInt(t_val.B200_220.value) };
        }
        if (t_val.B220_240.value > 0) {
          responce["240"] = { per: parseInt((t_val.B220_240.value / t_val.doc_count) * 100), count: parseInt(t_val.B220_240.value) };
        }
        if (t_val.greater_240.value > 0) {
          responce[">240"] = { per: parseInt((t_val.greater_240.value / t_val.doc_count) * 100), count: parseInt(t_val.greater_240.value) };
        }

        let res_result_final = [["Element", "percent", { type: 'string', role: "tooltip", 'p': { 'html': true } }, { role: "style" }]]

        let loop_keys = Object.keys(responce);
        loop_keys = ["<160", "180", "200", "220", "240", ">240"]

        loop_keys.map(x => {
          // res_result_final.push([x, responce[x].per, "<div><span>" + x + "</span><br/><span>Count " + responce[x].count + "</span><br/><span>percent " + responce[x].per + " &nbsp;</span></div>", "#83A4CF"]);
          res_result_final.push([x, responce[x].per, "<div><span>" + x + "</span><br/><span>Count " + responce[x].count + "</span><br/><span>percent " + responce[x].per + " &nbsp;</span></div>", "stroke-width: 1;stroke-color: black;"]);
        })
        setChartData((prestate) => res_result_final);
      } else {
        setChartData((prestate) => []);
      }
    }
  }


  const options = {
    hAxis: {
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
      ,
      gridlines: {
        color: 'transparent'
      },
      title: 'Range',
      minValue: 0,
      format: 'short',
    },
    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Discharge Cycles',
      minValue: 0,
      format: '#\'%\'',
    },
    bar: { groupWidth: "100%" },
    tooltip: { isHtml: true },
    legend: "none",
    isStacked: false,
    series: {
      0: { color: "#83A4CF" },
    },
  };

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + apiend, body: { filterdata: gloablfilter } }, appyData)
  }, [gloablfilter])

  return (
    <>
      <div className=" p-2">
        <div className="v-title">
          <div className="chartHGT">
            <WaterMark />
            {(isLoading) ? <ChartLoader /> : ((chartdata.length == 0) ? <NoData /> : <Chart chartType="ColumnChart" width="100%" height="230px" data={chartdata} options={options} />)}
          </div>
        </div>
      </div>
    </>
  );
}

export default RealWorldBar;
